import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor(private http: HttpClient) { }

    public reportWithdraw(transaction : any) : Observable<any>
    {
      return this.http.post<any>(`${environment.apiUrl}/reports/withdraw`,{transaction: transaction});
    }
}
